import React from 'react';
import { Link } from 'react-router-dom';
import './LandingPage.css';

const LandingPage = () => {
  return (
    <div className="landing-page">
      {/* Hero Sectionl */}
      <section className="hero-sectionl">
        <div className="hero-contentl">
          <h1>Transforming Businesses with SAP Solutions</h1>
          <p>Tailored Expertise. Real Solutions. Sustainable Growth.</p>
          <div className="hero-buttonsl">
            <Link to="/services" className="btn-primary">Explore Our Services</Link>
            <Link to="/contact-us" className="btn-secondary">Contact Us Today</Link>
          </div>
        </div>
      </section>

      {/* Why Choose Us Sectionl */}
      <section className="why-choose-usl">
        <h2>Solutions Designed for Your Success</h2>
        <div className="cards-container">
          <div className="card vertical">
            <img src="/assets/expertise.jpg" alt="Expertise in SAP" />
            <h3>SAP Implementation</h3>
            <p>Efficiently deploying SAP solutions tailored to your business needs.</p>
          </div>
          <div className="card horizontal">
            <img src="/assets/industry.jpg" alt="Industry-Specific Solutions" />
            <h3>Data Integration and Analytics</h3>
            <p>Seamless integration and actionable insights for strategic decisions.</p>
          </div>
          <div className="card vertical">
            <img src="/assets/data.jpg" alt="Data-Driven Innovation" />
            <h3>AI-Driven Process Optimization</h3>
            <p>Utilizing cutting-edge AI to enhance operational efficiency.</p>
          </div>
          <div className="card horizontal">
            <img src="/assets/client.jpg" alt="Client-Centric Philosophy" />
            <h3>Custom Enterprise Solutions</h3>
            <p>Crafting unique solutions to tackle complex business challenges.</p>
          </div>
        </div>
      </section>

     

      {/* Call-to-Action Sectionl */}
      <section className="cta-sectionl">
        <div className="cta-contentl">
          <h2>Let's Make It Happen</h2>
          <p>Get in touch with us today and explore how we can empower your business.</p>
          <div className="cta-buttonsl">
            <Link to="/contact-us" className="btn-secondary">Contact Us</Link>
            <Link to="/about-us" className="btn-primary">Learn More About Us</Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default LandingPage;